import React from 'react';
import { FaRegClock } from 'react-icons/fa';
import { Container, Row, Col } from 'react-bootstrap';
import { BG, TextoHorario } from './styles';

const HomeHorario = () => {
  return (
    <Container fluid className="bg-secondary border-0">
      <BG>
        <Row>
          <Col className="text-center p-4">
            <TextoHorario>
              <FaRegClock size={40} />
            </TextoHorario>
            <TextoHorario>HORÁRIO DE FUNCIONAMENTO</TextoHorario>
            <TextoHorario>DAS</TextoHorario>
            <TextoHorario
              style={{
                fontSize: '5rem',
                margin: 0,
                position: 'relative',
                top: -10,
              }}
            >
              10:30h as 15h
            </TextoHorario>
            <TextoHorario>DE SEGUNDA À SÁBADO</TextoHorario>
          </Col>
        </Row>
      </BG>
    </Container>
  );
};

export default HomeHorario;
